 <script>

import gsap from "gsap"
import { Howl, Howler } from 'howler'

export default {
  name: 'Sound',
  render: h => h(),
  data: ()=>({
    tw: null,
    use_continue: true,
    voice_ended: true,
    stopped: true,
    txt: ' - '
  }),

  beforeDestroy() {
    this.$ambiance.unload()
  },

  beforeCreate() {
    this.$ambiance = new Howl({
      src: [ require('@/commons/mp3/audio.mp3') ],
      loop: true,
      volume: .04
    })
    this.$trace = new Howl({
      src: [ require('@/commons/mp3/trace.mp3') ],
      loop: false,
      volume: 1,
      onplay: ()=> {
        this.voice_ended = false
      },
      onend: ()=> {
        this.voice_ended = true
      }
    })
    this.$block1 = new Howl({
      src: [ require('@/commons/mp3/block1.mp3') ],
      loop: false,
      volume: 1,
      onplay: ()=> {
        this.voice_ended = false
      },
      onend: ()=> {
        this.voice_ended = true
      }
    })
    this.$block3 = new Howl({
      src: [ require('@/commons/mp3/block3.mp3') ],
      loop: false,
      volume: 1,
      onplay: ()=> {
        this.voice_ended = false
      },
      onend: ()=> {
        this.voice_ended = true
      }
    })
    this.$race = new Howl({
      src: [ require('@/commons/mp3/race.mp3') ],
      loop: false,
      volume: 1,
      onplay: ()=> {
        this.voice_ended = false
      },
      onend: ()=> {
        this.voice_ended = true
      }
    })
    this.$option = new Howl({
      src: [ require('@/commons/mp3/options.mp3') ],
      loop: false,
      volume: 1,
      onplay: ()=> {
        this.voice_ended = false
      },
      onend: ()=> {
        this.voice_ended = true

        console.log('onend');

        gsap.delayedCall(2.5, ()=> { 

          console.log(this.use_continue);

          if(this.use_continue)
            this.$store.commit('app/SYNC_AUDIO', 'race') 
        })
      }
    })
  },

  computed: {
    sync_audio() { return this.$store.getters['app/audio'] },
  },

  watch: {
    '$route': {
      immediate: true,
      handler() {
        this.$nextTick(()=>{

          if(this.$route.params.section == 'weave')
            this.use_continue = true
          else 
            this.use_continue = false


          if(this.$route.params.section != 'voice' && this.stopped) 
            this.playAmbiance()      
          else if(this.$route.params.section == 'voice') 
            this.stopAmbiance()
          
        })
      }
    },
    sync_audio(nw, od) {

      console.log(nw, od, this.voice_ended);

      if(this.tw)
        this.tw.kill()

      let delay = .2
      if(this.voice_ended != true && od != 'none'){
        delay = 2
        this['$'+ od].fade(1, 0, 1000) 
        gsap.delayedCall(1.25, ()=> { 

          this['$'+ od].stop()
          this['$'+ od].volume(1)

        })
      }
    
      if(nw != 'none')  
        this.tw = gsap.delayedCall(delay, ()=> {
          this['$'+ nw].play()
        })
    },
  },

  mounted() {
    document.addEventListener('visibilitychange', this.checkVisibility)
    window.addEventListener('focus', this.focus)
    window.addEventListener('blur', this.blur)
  },

  methods: {
    checkVisibility() {   
      if(this.stopped == false) 
        this.stopAmbiance()
    },
    focus() {
      if(this.$route.params.section != 'voice' && this.stopped == true) {
        this.$ambiance.play()
        this.stopped = false
      }   
    },
    blur() {
      if(this.stopped == false) 
        this.stopAmbiance()
    },
    playAmbiance() {
      this.$ambiance.play()
      this.$ambiance.fade(0, .04, 500)
      this.stopped = false
    },
    stopAmbiance() {
      this.stopped = true
      this.$ambiance.stop()
    },
  }
}
</script>


